<template>
  <div class="post-block -report">
    <h3 class="post-block__title">{{ t('post_block_title') }}</h3>
    <div class="document-list">
      <a
        v-for="(item, index) in list"
        :key="index"
        class="document-list__link"
        :href="item.path"
        target="_blank"
      >
        <FileIcon class="document-list__icon" :text="item.type" />
        <div class="document-list__info">
          <p class="document-list__filename t1" v-html="item.name" />
          <p class="document-list__filesize t2">
            <span class="document-list__filetype" v-html="item.type" />
            <span v-html="item.size" />
          </p>
        </div>
        <Button
          class="document-list__download"
          size="-m"
          variant="-outline"
          :icon="true"
          title="Заголовок"
        >
          <FontIcon class="download" :size="'-m'" />
        </Button>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
  // import
  import { useI18n } from '#imports';
  import { Button } from '@nuxt-shared/ui/button';
  import { FontIcon } from '@nuxt-shared/ui/font-icon';
  import FileIcon from '@nuxt-shared/assets/svg/base/FileIcon.vue';

  const { t } = useI18n({ useScope: 'local' });

  // props
  const { className, list } = defineProps({
    className: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
  });
</script>

<style scoped lang="scss">
  .document-list {
    $this: &;

    display: flex;
    flex-direction: column;
    row-gap: 12px;

    &__link {
      display: grid;
      grid-template-columns: 64px 1fr 48px;
      column-gap: 24px;
      padding: 24px 32px;
      border-radius: 8px;
      border: 1px solid $black30;
      transition: all 0.3s ease-in-out;

      @include until($xl) {
        grid-template-columns: 60px 1fr 40px;
      }

      &:hover {
        border-color: $purple;

        #{$this}__filename {
          color: $purple;
        }

        #{$this}__download {
          border-color: var(--aton-button-outline-hover-border-color);
        }
      }
    }

    &__icon {
      width: 100%;
      max-width: 64px;
      height: auto;
    }

    &__info {
      display: flex;
      flex-direction: column;
      row-gap: 8px;
    }

    &__filename {
      transition: all 0.3s ease-in-out;
      word-break: break-word;
    }

    &__filesize {
      color: $black70;
    }

    &__filetype {
      text-transform: uppercase;
    }
  }
</style>

<i18n lang="json">
{
  "ru": {
    "post_block_title": "Скачать материалы"
  }
}
</i18n>
